/* @flow */

import { rem } from 'polished';

import { gutter } from 'src/shared/app/base/style/token/grid';
import { tablet } from '@e180/ui/lib/token/mediaQuery';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'fixed',
    left: 0,
    right: 0,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    width: '100%',
    maxWidth: 540,
    height: '100%',
    margin: 'auto',
    padding: [0, gutter],
  },
  hero: {
    /* FIXME: Handle all resolutions without specific edge cases */
    '@media only screen and (max-width: 350px)': {
      fontSize: rem(30, baseFontSize),
    },
  },
  branding: {
    position: 'absolute',
    left: 16,
    top: 8,

    [tablet]: {
      display: 'none',
    },
  },
  link: {
    position: 'absolute',
    right: 16,
    top: 16,

    [tablet]: {
      position: 'fixed',
      right: 24,
      top: 24,
    },
  },
  body: {
    position: 'relative',

    /* IE11 required */
    maxWidth: 'inherit',

    textAlign: 'center',
  },
  submit: {
    display: 'flex',
    justifyContent: 'center',

    marginTop: 24,
  },
};
